import { render, staticRenderFns } from "./ProdProcessTableRow.vue?vue&type=template&id=381c4431&"
import script from "./ProdProcessTableRow.vue?vue&type=script&lang=js&"
export * from "./ProdProcessTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports